import { useMutation, useQueryClient, UseMutationOptions } from "@tanstack/react-query";

import { ENDPOINTS } from "@/api/application-api";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";

export interface ResetChatFromRequestResponseI {
  success: boolean;
  deleted_count: number;
  has_initial_chat_history: boolean;
  initial_chat_history_count: number;
}

export interface ResetChatFromRequestParamsI {
  workspaceId: number;
  sessionId: string;
  request: {
    request_log_id: number;
    variable_set_index: number;
    input_variables: Record<string, string>;
  };
}

export const useAPIResetChatFromRequest = (
  userToken: string,
  options?: UseMutationOptions<ResetChatFromRequestResponseI, Error, ResetChatFromRequestParamsI>,
) => {
  const queryClient = useQueryClient();

  return useMutation<ResetChatFromRequestResponseI, Error, ResetChatFromRequestParamsI>(
    variables =>
      fetch(ENDPOINTS.reset_chat_from_request(variables.workspaceId, variables.sessionId), {
        method: "POST",
        headers: jsonAuthHeaders(userToken),
        body: JSON.stringify(variables.request),
      }).then(handleResponse),
    {
      onSuccess: (_, variables) => {
        queryClient.invalidateQueries([
          "playground-session-chat-messages",
          variables.workspaceId,
          variables.sessionId,
        ]);
      },
      ...options,
    },
  );
};
